import React from 'react';
import classNames from 'classnames';
import './save-button.scss';

const SaveButton = props => {
    
    return (
        <button className={classNames({
            'form__button': true,
            'report-save-btn': true,
            'report-save-btn--is-loading': props.isLoading,
            'report-save-btn--is-saved': props.isSaved,
            ...props.modifiers
        })} type={props.type ? props.type : 'button'} onClick={props.onClick} {...props.attr}>
            <span className="report-save-btn__inner report-save-btn__inner--normal">
                {props.text}
            </span>
            <span className="report-save-btn__inner report-save-btn__inner--loading">
                <span className="spinner-bounce">
                    <span className="bounce1"></span>
                    <span className="bounce2"></span>
                    <span className="bounce3"></span>
                </span>
                {props.textSaving}
            </span>

            <span className="report-save-btn__inner report-save-btn__inner--saved">{props.textSaved}</span>
        </button>
    );
};

export default SaveButton;